import { Chip, Divider, Paper } from "@mui/material";
import styled from "@emotion/styled";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

export const TruckFlyoutContainer = styled(Paper)({
	display: "flex",
	flexDirection: "column",
	position: "fixed",
	top: 0,
	right: 0,
	width: "375px",
	height: "100%",
	overflowY: "auto"
});

export const TruckFlyoutHeaderContainer = styled.div({
	padding: "0 16px"
});

export const TruckFlyoutTitleContainer = styled.div(({ theme }) => ({
	display: "flex",
	alignItems: "center",
	justifyContent: "space-between",
	minHeight: "64px",
	h5: {
		...theme.project.typography.heading.h5,
		margin: 0
	},
	button: {
		padding: 0,
		svg: {
			color: theme.palette.text.secondary
		}
	}
}));

export const TruckFlyoutHeaderDetailsContainer = styled.div({
	display: "flex",
	flexDirection: "column",
	gap: "8px",
	marginBottom: "16px"
});

export const TruckFlyoutIdHeader = styled.div({
	display: "flex",
	justifyContent: "space-between",
	gap: "8px",
	h6: {
		margin: 0,
		wordBreak: "break-all"
	}
});

export const TruckFlyoutOrderDate = styled.div(({ theme }) => ({
	...theme.project.typography.overline,
	color: theme.palette.text.secondary,
	marginBottom: "4px"
}));

export const TruckFlyoutHeaderDivider = styled(Divider)(({ theme }) => ({
	width: "100%",
	backgroundColor: theme.palette.divider
}));

export const TruckFlyoutStatusDetails = styled.div(({ theme }) => ({
	backgroundColor: theme.project.colors.backgroundColors.secondary,
	gap: "4px",
	display: "flex",
	justifyItems: "space-between",
	flexDirection: "column",
	padding: "16px"
}));

export const TruckFlyoutStatusChip = styled(Chip)(({ theme }) => ({
	...theme.project.typography.chipLabel,
	display: "flex",
	height: "1.5rem",
	alignItems: "center",
	backgroundColor: "transparent",
	borderColor: theme.project.colors.primaryColors.main,
	textTransform: "capitalize",
	borderRadius: "100px",
	border: "1px solid",
	color: theme.project.colors.primaryColors.main,
	width: "fit-content",
	"& .MuiChip-label": {
		paddingTop: 2.5
	},
	marginBottom: "4px"
}));

export const TruckFlyoutDeliveryDetails = styled.div(({ theme }) => ({
	display: "flex",
	justifyItems: "space-between",
	flexDirection: "column",
	"> div": {
		gap: "4px",
		display: "flex",
		justifyItems: "space-between",
		alignContent: "center",
		flexDirection: "row",
		span: {
			...theme.project.typography.subtitle.subtitle1,
			color: theme.palette.text.primary
		}
	},
	h5: {
		...theme.project.typography.heading.h5,
		color: theme.palette.text.primary,
		margin: 0
	}
}));

export const InfoIcon = styled(InfoOutlinedIcon)(({ theme }) => ({
	color: theme.project.colors.primaryColors.main,
	alignSelf: "center",
	width: "16px"
}));

export const TruckFlyoutRequestedDeliveryDate = styled.div(({ theme }) => ({
	...theme.project.typography.caption,
	color: theme.palette.text.secondary
}));

export const TruckFlyoutDetails = styled.div({
	padding: "16px",
	display: "flex",
	flexDirection: "column",
	gap: "16px"
});

export const TruckFlyoutAccountDetails = styled.div(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	gap: "8px",
	div: {
		display: "flex",
		flexDirection: "column",
		"span:first-of-type": {
			...theme.project.typography.subtitle.subtitle2
		},
		"span:last-of-type": {
			...theme.project.typography.body.body2
		}
	}
}));

export const TruckFlyoutStopContainer = styled.div({
	display: "flex",
	flexDirection: "column",
	gap: "16px"
});

export const TruckFlyoutOrdersContainer = styled.div({
	gap: "16px",
	display: "flex",
	justifyItems: "space-between",
	alignContent: "center",
	flexDirection: "column",
	flexGrow: 1
});

export const TruckFlyoutStopAddress = styled.div(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	"span:first-of-type": {
		...theme.project.typography.subtitle.subtitle2
	},
	"span:last-of-type": {
		...theme.project.typography.body.body2
	}
}));

export const TruckFlyoutResultsText = styled.div(({ theme }) => ({
	...theme.project.typography.overline,
	color: theme.project.colors.fontColors.main
}));

export const TruckFlyoutStopDividerContainer = styled.div({
	padding: "16px 0"
});
